import React from 'react'
import { useIntl } from 'react-intl'
import { ConfigDetail, UserDashboardKeys } from '@manager/models/userDashboard'
import { Box, IconButton } from '@mui/material'
import { StatusCapsule } from '@components/Capsule'
import ListTable from '@src/components/ListTable'
import GlobalDialog from '@src/components/GlobalDialog'
import { ReactComponent as IconDelete } from '@src/assets/icons/iconDelete.svg'
import { ReactComponent as IconEdit } from '@src/assets/icons/iconEdit.svg'
import SubTitle from './SubTitle'
import commonMessages from '@common/messages'

export default function ConfigTable({
  title,
  configList,
  onCreate,
  onEdit,
  onDelete,
}: {
  title: string
  configList: ConfigDetail[]
  onCreate: () => void
  onEdit: (id: string) => void
  onDelete: (id: string) => void
}) {
  const { formatMessage: f } = useIntl()

  const handleDelete = (id: string) => {
    onDelete(id)
  }

  const beforeDelete = (id: string) => {
    GlobalDialog.open({
      content: f(commonMessages.confirmDeleteConfig),
      onAgree: () => handleDelete(id),
    })
  }

  return (
    <>
      <SubTitle title={title} onCreate={onCreate} />
      <ListTable
        noMarginTop
        dataList={configList}
        theadList={[
          {
            id: UserDashboardKeys.Code,
            label: f(commonMessages.cfgCode),
          },
          {
            id: UserDashboardKeys.Active,
            label: f(commonMessages.status),
            formatter: (isActivated: boolean) => (
              <StatusCapsule isActivated={isActivated} />
            ),
          },
          {
            id: UserDashboardKeys.Description,
            label: f(commonMessages.description),
          },
          {
            id: UserDashboardKeys.Code,
            label: '',
            formatter: (id: string) => (
              <Box display="flex" flexDirection="row-reverse">
                <IconButton
                  sx={({ palette }) => ({
                    marginLeft: 1,
                    bgcolor: palette.error.main,
                    '&>svg': { width: 15, height: 15 },
                  })}
                  onClick={(e) => beforeDelete(id)}>
                  <IconDelete />
                </IconButton>
                <IconButton
                  sx={({ palette }) => ({
                    bgcolor: palette.primary.main,
                    '&>svg': { width: 15, height: 15 },
                  })}
                  onClick={() => onEdit(id)}>
                  <IconEdit />
                </IconButton>
              </Box>
            ),
          },
        ]}
      />
    </>
  )
}
